import { cva } from '@/styled-system/css';

export const progressRangeRecipe = cva({
  base: {
    position: 'absolute',
    zIndex: '2',
    insetBlock: 0,
    insetInlineStart: 0,
    transition: {
      _motionReduce: 'none',
      _motionSafe: '{transitions.ProgressIndicator.bar}',
    },
  },
  variants: {
    size: {
      md: {
        borderRadius: 'ProgressIndicator.bar.md',
      },
      sm: {
        borderRadius: 'ProgressIndicator.bar.sm',
      },
    },
    complete: {
      true: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.complete',
      },
      false: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.active',
      },
    },
  },
});
